import React from 'react';
import { Link } from 'react-router-dom';

export default ({
  onClick,
  url,
  title,
  icon,
  className,
  role,
  isDiv,
  isLink,
  disabled,
  target,
  faPrefix,
}) => {
  return (
    <>
      {isDiv ? (
        <div
          className={className}
          onClick={onClick}
          role={role}
          disabled={disabled}
        >
          <i
            className={`fa-${faPrefix || 'solid'} fa-${icon}`}
            title={title}
          ></i>
        </div>
      ) : isLink ? (
        <Link
          to={url}
          className={className}
          role={role}
          disabled={disabled}
          target={target}
        >
          <i
            className={`fa-${faPrefix || 'solid'} fa-${icon}`}
            title={title}
          ></i>
        </Link>
      ) : (
        <a
          className={className}
          href={url}
          role={role}
          onClick={onClick}
          disabled={disabled}
        >
          <i
            className={`fa-${faPrefix || 'solid'} fa-${icon}`}
            title={title}
          ></i>
        </a>
      )}
    </>
  );
};
